import useFormDataGetPageDataByRequest from '../../../@hooks/useFormDataGetPageDataByRequest'
import service from '../../../@services'
export default function useGetCheckList() {
  const { pageData, getList, loading } = useFormDataGetPageDataByRequest(
    service.inventory.getCheckSheetList
  )
  return {
    pageData,
    getList,
    loading
  }
}
